module.exports = __webpack_public_path__ + "img/Estacionamiento bicicletas.c3766525.png";